module.exports = __webpack_public_path__ + "static/media/image_50.6e6b3c81.png";